import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../theme';

interface ThemeToggleProps {
  /** Renders full width with a label, for the mobile sheet. */
  expanded?: boolean;
  className?: string;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ expanded = false, className = '' }) => {
  const { isDark, toggle } = useTheme();
  const nextLabel = isDark ? 'Switch to light theme' : 'Switch to dark theme';

  // Both icons stay mounted and cross-fade, so the control never reflows.
  const icons = (
    <span className="relative block h-5 w-5" aria-hidden="true">
      <Sun
        strokeWidth={1.5}
        className={`absolute inset-0 h-5 w-5 transition-all duration-300 ${
          isDark ? 'rotate-0 opacity-100' : '-rotate-90 opacity-0'
        }`}
      />
      <Moon
        strokeWidth={1.5}
        className={`absolute inset-0 h-5 w-5 transition-all duration-300 ${
          isDark ? 'rotate-90 opacity-0' : 'rotate-0 opacity-100'
        }`}
      />
    </span>
  );

  if (expanded) {
    return (
      <button
        type="button"
        onClick={toggle}
        aria-label={nextLabel}
        className={`flex w-full items-center justify-between border border-line px-5 py-4 text-left text-[15px] font-medium text-ink transition-colors hover:border-ink ${className}`}
      >
        {isDark ? 'Light theme' : 'Dark theme'}
        {icons}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={nextLabel}
      title={nextLabel}
      className={`flex h-10 w-10 items-center justify-center border border-line text-muted transition-colors hover:border-ink hover:text-ink ${className}`}
    >
      {icons}
    </button>
  );
};

export default ThemeToggle;
